import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#702963', // Byzantium - primary buttons, active nav
      light: '#8D3E7E',
      dark: '#59214F',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#009999', // Viridian Green - accepted / success
      light: '#33ADAD',
      dark: '#007A7A',
      contrastText: '#ffffff',
    },
    error: {
      main: '#AB0E0E', // Dark Red - errors & closed nominations
      light: '#BC3A3A',
      dark: '#890B0B',
      contrastText: '#ffffff',
    },
    info: {
      main: '#FFFFF', // Viridian Green - changed to match nominations
      light: '#33ADAD',
      dark: '#007A7A',
      contrastText: '#ffffff', // Updated for better contrast
    },
    background: {
      default: '#f1f5f9', // Greyish background for better contrast
      paper: '#ffffff', // Pure white for cards and papers
      card: 'rgba(255, 255, 255, 0.95)', // Semi-transparent white for glassmorphism
    },
    highlight: {
      main: '#D8EFEF', // Sky - gentle highlights & card hovers
    },
    text: {
      primary: '#2d3748', // Darker gray for better contrast
      secondary: '#4a5568', // Medium gray for secondary text
    },
  },
  typography: {
    fontFamily: '"Space Grotesk", "Geist", "Satoshi", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem', // 28px section titles
      fontWeight: 600,
      color: '#009999', // Viridian Green for h1 
    },
    h4: {
      fontSize: '1.75rem', // 28px section titles
      fontWeight: 600,
      color: '#009999', // Viridian Green for h1 
    },
    body1: {
      fontSize: '0.875rem', // 14px body
    },
    body2: {
      fontSize: '0.75rem',
    },
    button: {
      fontSize: '0.875rem',
      textTransform: 'none',
    },
  },
  components: {

    MuiCssBaseline: {
      styleOverrides: {
        'input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px var(--input-bg) inset',
          boxShadow: '0 0 0 1000px var(--input-bg) inset',
          WebkitTextFillColor: '#2d3748',
          caretColor: '#2d3748',
          transition: 'background-color 9999s ease-out 0s',
        },
        'input:-webkit-autofill:focus, textarea:-webkit-autofill:focus, select:-webkit-autofill:focus': {
          WebkitBoxShadow: '0 0 0 1000px var(--input-bg) inset',
          boxShadow: '0 0 0 1000px var(--input-bg) inset',
        },
        /* Firefox */
        'input:-moz-autofill, textarea:-moz-autofill, select:-moz-autofill': {
          boxShadow: 'inset 0 0 0 1000px var(--input-bg)',
          color: '#2d3748',
          caretColor: '#2d3748',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '14px', // 14px corner radius
          padding: '8px 16px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          transition: 'all 0.2s ease-in-out',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '14px', // 14px corner radius
          backdropFilter: 'blur(10px)', // Glassmorphism effect
          boxShadow: '0 8px 32px rgba(0,0,0,0.2)', // depth-3 shadows
          background: 'rgba(127, 140, 156, 0.7)', // Semi-transparent background
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '14px',
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: '0 8px 32px rgba(216, 239, 239, 0.3)',
            borderColor: '#D8EFEF',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '14px',
            '&.Mui-focused fieldset': {
              borderColor: '#702963',
              boxShadow: '0 0 0 3px rgba(112, 41, 99, 0.2)',
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
        },
      },
    },
  },
});

export default theme;
